import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseApi from "../../api/baseApi";

import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialState = {
  payment: {},
  paymentLoading: true,
  paymentRefresh: true,

  payments: [],
  paymentsLoading: true,
  paymentsRefresh: true,

  cardInfo: {},
  cardInfoLoading: true,
  cardInfoRefresh: true,

  createPaymentLoading: false,
  updatePaymentLoading: false,
  deletePaymentLoading: false,
};

export const findBin = createAsyncThunk("payment/findBin", async (bin) => {
  if (!bin) throw new Error("Bin bulunamadı!");

  try {
    const response = await baseApi.get(`/Payment/Bin?bin=${bin}`);

    return response.data.Value;
  } catch (error) {
    throw new Error(error.response.data.errorMessage);
  }
});

export const paymentSlice = createSlice({
  name: "payment",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(findBin.pending, (state, action) => {
        state.cardInfo = {};
        state.cardInfoLoading = true;
      })
      .addCase(findBin.fulfilled, (state, action) => {
        state.cardInfo = action.payload;
        state.cardInfoLoading = false;
      })
      .addCase(findBin.rejected, (state, action) => {
        state.cardInfo = {};
        state.cardInfoLoading = false;
      });
  },
});

export default paymentSlice.reducer;
